module.exports = __webpack_public_path__ + "static/media/mom2.431770b0.jpg";